<ng-template #modal let-dismiss="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">When was it done?</h5>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Let us know when you received the vaccine so we can update your chart.</p>
    <om-date-entry [form]="dateEntryForm"></om-date-entry>
  </div>
  <div class="modal-footer flex-wrap">
    <p>Do not click complete until after you have received this vaccine.</p>
    <button (click)="dismiss()" class="btn btn-alternate">Cancel</button>
    <button (click)="complete()" [disabled]="!dateEntryForm.valid" class="btn btn-primary"> Complete </button>
  </div>
</ng-template>
